import {
  faHome,
  faGear,
  faCircle,
  faCartShopping,
  faUtensils,
  faTicket,
  faMoneyBillWave,
  faUser,
  faPersonBiking,
  faUserTie,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";

const verticalNavigation = [
  {
    id: "home",
    title: "Home",
    icon: faHome,
    navLink: "/",
    resource: "home",
  },
  {
    id: "adminmanagement",
    title: "Admins",
    icon: faUserTie,
    navLink: "/admins/*",
    resource: "admins",
    subMenu: [
      {
        id: "adminsearch",
        title: "Admins List",
        navLink: "/admins/admins-list",
        icon: faCircle,
      },
    ],
  },
  {
    id: "restaurantmanagment",
    title: "Restaurants",
    icon: faUtensils,
    navLink: "/restaurants/*",
    resource: "restaurants",
    subMenu: [
      {
        id: "restaurantsearch",
        title: "Restaurants List",
        navLink: "/restaurants/restaurants-list",
        icon: faCircle,
      },
      {
        id: "restaurantAdd",
        title: "Restaurant Creation",
        navLink: "/restaurants/create-restaurant",
        icon: faCircle,
      },
    ],
  },
  {
    id: "carts",
    title: "Carts",
    icon: faCartShopping,
    resource: "carts",
    navLink: "/carts/*",
    subMenu: [
      {
        id: "carts",
        title: "Carts List",
        navLink: "/carts/carts-list",
        icon: faCircle,
      },
    ],
  },
  {
    id: "cartpersons",
    title: "Cart Persons",
    icon: faPersonBiking,
    resource: "cartpersons",
    navLink: "/cartpersons/*",
    subMenu: [
      {
        id: "cartpersons",
        title: "Cart Person",
        navLink: "/cartpersons/cartperson-list",
        icon: faCircle,
      },
    ],
  },
  {
    id: "customers",
    title: "Customers",
    icon: faUser,
    navLink: "/customers/*",
    resource: "customers",
    subMenu: [

      {
        id: "customerlist",
        title: "Customer List",
        navLink: "/customers/customer-list",
        icon: faCircle,
      }
    ],
  },
  {
    id: "organizations",
    title: "Organizations",
    icon: faBuilding,
    navLink: "/organizations/*",
    resource: "organizations",
    subMenu: [
      {
        id: "organizationlist",
        title: "Organization List",
        navLink: "/organizations/organization-list",
        icon: faCircle,
      },
    ],
  },
  {
    id: "rolesAndPermissions",
    title: "Roles And Permissions",
    icon: faUser,
    navLink: "/roles-and-permissions/*",
    resource: "rolesAndPermissions",
    subMenu: [
      {
        id: "roleManagement",
        title: "Role Management",
        navLink: "/roles-and-permissions/role-management",
        icon: faCircle,
      },
    ],
  },
  {
    id: "configuration",
    title: "Configuration",
    icon: faGear,
    resource: "configuration",
    navLink: "/configuration/*",
    subMenu: [
      {
        id: "cartDevice",
        title: "Configure Cart Device",
        navLink: "/configuration/deviceConfiguration",
        icon: faCircle,
      },
      {
        id: "commission",
        title: "Commission",
        navLink: "/configuration/commission",
        icon: faCircle,
      },
    ],
  },
  {
    id: "promoCode",
    title: "Promo Code",
    icon: faTicket,
    navLink: "/promo-code",
    resource: "promoCode",
  },
  {
    id: "payment",
    title: "Payment",
    icon: faMoneyBillWave,
    navLink: "/payment",
    resource: "payment",
    subMenu: [
      {
        id: "customer-refunds",
        title: "Customer Refunds",
        navLink: "/payment/order-Refund",
        icon: faCircle,
      },
      {
        id: "payout ",
        title: "Payout ",
        navLink: "/payment/payout",
        icon: faCircle,
      },
    ],
  },
];

export default verticalNavigation;
